<template>
    <div class="flex max-w-480 flex-wrap bg-white rounded border border-primary-20 overflow-hidden shadow-md p-16 -mr-4">
        <button
            v-for="value in filteredVariables"
            :key="value.placeholder"
            @click="$emit('select', value.placeholder)"
            class="leading-none rounded-sm h-24 px-8 bg-primary text-white font-semibold trans-ease hover:bg-primary-60 mb-4 mr-4 first-letter:uppercase"
        >
            {{ value.label }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        categories: {
            type: Array,
            required: true,
        }
    },
    data: function () {
        return {
            variables: {
                application: [
                    { placeholder: 'first_name', label: this.$t('email_placeholders.first_name') },
                    { placeholder: 'last_name', label: this.$t('email_placeholders.last_name') },
                    { placeholder: 'email', label: this.$t('email_placeholders.email') },
                    { placeholder: 'job_title', label: this.$t('email_placeholders.job_title') },
                ],
                company: [
                    { placeholder: 'company_name', label: this.$t('email_placeholders.company_name') },
                    { placeholder: 'company_email', label: this.$t('email_placeholders.company_email') },
                    { placeholder: 'company_website', label: this.$t('email_placeholders.company_website') },
                    { placeholder: 'company_workat_website', label: this.$t('email_placeholders.workat_website') },
                ],
                user: [
                    { placeholder: 'user_name', label: this.$t('email_placeholders.user_name') },
                    { placeholder: 'user_email', label: this.$t('email_placeholders.user_email') },
                    { placeholder: 'company_user_position', label: this.$t('email_placeholders.position') },
                    { placeholder: 'company_user_phone', label: this.$t('email_placeholders.company_phone') },
                ],
                job: [
                    { placeholder: 'job_title', label: this.$t('email_placeholders.job_title') },
                ],
                interviewInvitation: [
                    { placeholder: 'interview_location', label: this.$t('email_placeholders.interview_location') },
                ],
                interviewInvitationConfirmed: [
                    { placeholder: 'interview_date', label: this.$t('email_placeholders.interview_date') },
                    { placeholder: 'interview_time', label: this.$t('email_placeholders.interview_time') },
                    { placeholder: 'interviewer', label: this.$t('email_placeholders.interviewer') },
                ]
            }
        }
    },
    computed: {
        filteredVariables () {

            let vars = [];

            this.categories.forEach(cat => {
                vars = [...vars, ...this.variables[cat]];
            });

            // vars.sort((a, b) => a.label > b.label ? 1 : -1);

            return vars;
        }
    }
}
</script>
